module.exports = __webpack_public_path__ + "095f7c182e20111af685e42d4675fb55.svg";